/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description Helper function configure message
 */

import { APP_HOSTNAME } from '@zcode/nr-utils'
import type { Listable, Property } from '@zcode/state-type'
import { getBuildingDefaultMessage, getListingDefaultMessage } from '../../../constants/message'

function configureMsg(entity: null | undefined, viewingTime?: string): null
function configureMsg(entity: Listable | Property, viewingTime?: string): string
function configureMsg(entity: Listable | Property | null | undefined, viewingTime?: string) {
  if (entity) {
    if (entity.isBuilding) {
      return getBuildingDefaultMessage({
        url: `https://${APP_HOSTNAME}${entity.url}`,
        buildingName: entity.name ?? undefined,
      })
    }
    return getListingDefaultMessage({
      url: `https://${APP_HOSTNAME}${entity.url}`,
      viewingTime,
    })
  }
  return null
}

export default configureMsg
